import { Organisation, buildOrganisationFromDetail } from "../organisation/Organisation";
import { Transactor, buildTransactorFromDetail } from "./Transactor";

export class TransactorOrganisation {
    transactor: Transactor
    organisation: Organisation
    control_org?: boolean = false

    constructor(transactor: Transactor, organisation: Organisation, control_org?: boolean) {
        this.transactor = transactor
        this.organisation = organisation
        this.control_org = control_org
    }
}

export function buildTransactorOrganisationDetail(to: any): TransactorOrganisation {
    return new TransactorOrganisation(
        to?.transactor ? buildTransactorFromDetail(to.transactor) : undefined,
        to.organisation ? buildOrganisationFromDetail(to.organisation) : undefined,
        to.control_org)
}

export function buildFromShObject(o: any) {

    const org = buildOrganisationFromDetail({
        employees: o.employees.map(e => {
            return {
                transactor_id: e.transactor_id,
                transactor: {
                    id: e.transactor_id,
                    person: {
                        id: e.person_id,
                        firstname: e.first_name,
                        lastname : e.last_name,
                        user: {
                            avatar_url: e.avatar_uri,
                        },
                        location: e.location
                    }
                }
            }
        }),
        organisation_type: o.mill.organisation.type,
        positionepsg4326: o.mill.organisation.position,
        grading: o.grading,
        ...o.mill.organisation,
        ...o.mill,        
    })

    return new TransactorOrganisation(
        o?.transactor,
        org,
        o?.control_org)
}